<template>
  <div
    class="cases"
    :class="getVariant('cases')"
  >
    <image-view
      variant="is-dark"
      :skills="caseStudy.skills"
      :image-id="caseStudy.image.url"
      :mobile-image-id="caseStudy.mobileimage.url"
    >
      <!-- Title (first) -->
      <template
        slot="title-small"
      >
        {{ caseStudy.client }}
      </template>

      <!-- Title (second) -->
      <template slot="title-normal">
        {{ caseStudy.name }}
      </template>

      <template slot="skill-title">
        <text-view
          variant="skill"
        >
          <p>{{ $t('skills') }}</p>
        </text-view>
      </template>
      <template
        slot="skill"
        slot-scope="props"
      >
        <text-view
          variant="skill"
        >
          <p>{{ props.skill }}</p>
        </text-view>
      </template>
    </image-view>
    <div
      class="cases__content"
      variant="plus-margin"
    >
      <!-- Title -->
      <title-view variant="primary ">
        {{ caseStudy.name }}
      </title-view>

      <!-- Subtitle -->

      <div class="has-max-width">
        <div
          class="cases__content"
          :class="'has-max-width--padding'"
        >
          <title-view variant="subtitle">
            <span>{{ caseStudy.lead }}</span>
          </title-view>
        </div>
      </div>
    </div>

    <!-- List Case Items -->
    <div
      v-for="(item, index) in caseStudy.items"
      :key="index"
    >
      <!-- Text -->
      <div
        class="has-max-width--padding"
      >
        <div
          v-if="item.type === typeCase.TYPE_TEXT"
          class="cases__content"
        >
          <title-view
            variant="small small-margin align-left no-padding black"
          >
            {{ item.title }}
          </title-view>
          <text-view
            variant="align-left normal"
            v-html="item.text"
          />
        </div>
      </div>

      <!-- Big Image -->
      <div
        v-if="item.type === typeCase.TYPE_IMAGE"
        :class="{'has-max-width': !item.style.HasMargin}"
      >
        <div class="cases__big-image">
          <picture>
            <source
              media="--small"
              :data-srcset="item.mobileimage.url"
            >

            <source
              media="--large"
              :data-srcset="item.image.url"
            >

            <img
              class="lazyload"
              data-sizes="auto"
              :data-src="item.image.url"
            >
          </picture>
        </div>
      </div>

      <!-- Video -->
      <div
        v-if="item.type === typeCase.TYPE_VIDEO"
      >
        <video-thumbnail-inline-view
          :variant="getVideoWidth(item.fullwidth)"
          :video-id="item.vimeourl"
        >
          <template slot="image">
            <picture>
              <source
                media="--small"
                :data-srcset="item.mobilethumbnail.url"
              >

              <source
                media="--large"
                :data-srcset="item.thumbnail.url"
              >

              <img
                class="lazyload"
                data-sizes="auto"
                :data-src="item.thumbnail.url"
              >
            </picture>
          </template>
        </video-thumbnail-inline-view>
      </div>

      <!-- Main Features -->
      <div
        v-if="item.type === 3"
      >
        <div
          class="has-max-width"
          :class="'has-max-width--padding'"
        >
          <div
            class="cases__content"
            :class="'cases__content--full'"
          >
            <title-view
              variant="small small-margin align-left no-padding black"
            >
              {{ item.title }}
            </title-view>
          </div>
        </div>
        <div
          v-for="(storyItem, ind) in item.items"
          :key="ind"
        >
          <div
            v-if="storyItem.type === typeCase.TYPE_TEXT"
            class="cases__content"
            :class="'has-max-width--padding'"
          >
            <text-view
              variant="align-left normal no-pre-line"
            >
              {{ storyItem.text }}
            </text-view>
          </div>
          <div
            v-if="storyItem.type === typeCase.TYPE_IMAGE"
          >
            <div
              :class="{'has-max-width': !storyItem.fullwidth}"
            >
              <picture>
                <source
                  media="--small"
                  :data-srcset="storyItem.mobileimage.url"
                >

                <source
                  media="--large"
                  :data-srcset="storyItem.image.url"
                >

                <img
                  class="lazyload"
                  data-sizes="auto"
                  :data-src="storyItem.image.url"
                >
              </picture>
            </div>
          </div>
        </div>
      </div>

      <!-- Awards -->
      <div
        v-if="item.type === typeCase.TYPE_AWARDS"
        class="cases__awards"
      >
        <!-- Title -->
        <title-view
          variant="big"
        >
          {{ $t('awards') }}
        </title-view>
        <section class="center grid-2-spaceAround">
          <div
            v-for="(award, i) in item.items"
            :key="i"
            class="col-6_sm-12"
          >
            <award-view
              :title="award.title"
              :year="award.year"
            />
          </div>
        </section>
      </div>

      <!-- Button -->
      <div
        v-if="item.type === typeCase.TYPE_BUTTONLIST"
        class="cases__buttons"
      >
        <!-- Title -->
        <title-view variant="primary ">
          {{ item.heading }}
        </title-view>
        <section class="cases__buttons__grid center grid-center-spaceAround">
          <div
            v-for="(button, i) in item.items"
            :key="i"
            class="col-6_sm-12"
          >
            <div
              v-if="button.type.id === typeButtonCase.TYPE_IOS"
              class="cases__buttons__grid__button"
            >
              <a
                :href="button.action"
                target="_blank"
              >
                <picture>
                  <source
                    media="--small"
                    data-srcset="/static/images/appstore.png"
                  >

                  <source
                    media="--large"
                    data-srcset="/static/images/appstore@2x.png"
                  >

                  <img
                    class="lazyload"
                    data-sizes="auto"
                    data-src="/static/images/appstore@2x.png"
                  >
                </picture>
              </a>
            </div>

            <div
              v-if="button.type.id === typeButtonCase.TYPE_ANDROID"
              class="cases__buttons__grid__button"
            >
              <a
                :href="button.action"
                target="_blank"
              >
                <picture>
                  <source
                    media="--small"
                    data-srcset="/static/images/googleplay.png"
                  >

                  <source
                    media="--large"
                    data-srcset="/static/images/googleplay@2x.png"
                  >

                  <img
                    class="lazyload"
                    data-sizes="auto"
                    data-src="/static/images/googleplay@2x.png"
                  >
                </picture>
              </a>
            </div>
            <div
              v-if="button.type.id === typeButtonCase.TYPE_WEB"
              class="cases__buttons__grid__button"
            >
              <a
                :href="button.action"
                target="_blank"
              >
                <button-view variant="primary full">
                  <i class="icon-website" /><span>{{ button.label }}</span>
                </button-view>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Footer -->
    <footer-contact-view />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import variant from '@/mixins/variant';

import ENVIRONMENT from '@/env';
import * as typeCase from '@/utils/case-types';
import * as typeButtonCase from '@/utils/case-button-types';

export default {
  name: 'CaseShow',

  components: {
    TitleView: () => import('@/components/title/title-view'),
    TextView: () => import('@/components/text/text-view'),
    VideoThumbnailInlineView: () => import('@/components/video/video-thumbnail-inline-view'),
    ImageView: () => import('@/components/image/image-view'),
    AwardView: () => import('@/components/awards/award-view'),
    FooterContactView: () => import('@/components/footer/footer-contact-view'),
    ButtonView: () => import('@/components/button/button-view')
  },

  mixins: [variant],

  data() {
    return {
      typeCase: typeCase,
      typeButtonCase: typeButtonCase
    };
  },
  computed: {
    ...mapState('cases', {
      caseStudy: (state) => state.case
    }),

    baseUrl() {
      return ENVIRONMENT.baseUrl;
    },

    shareUrl() {
      return `${this.baseUrl}/work/${this.caseStudy.slug}`;
    }
  },

  mounted() {
    const { id } = this.$route.params;
    this.getCaseById(id);
  },

  methods: {
    ...mapActions('cases', [
      'getCaseById'
    ]),

    getVideoWidth(width) {
      if (width) {
        return 'fullwidth';
      }
      return 'full';
    }

  },

  metaInfo() {
    return {
      title: `Work: ${this.caseStudy.name}`,
      meta: [
        {
          name: 'description',
          content: this.caseStudy.name
        },
        {
          property: 'og:url',
          content: this.shareUrl
        },
        {
          property: 'og:title',
          content: this.caseStudy.name
        },
        {
          property: 'og:description',
          content: `${this.caseStudy.name}:  ${this.caseStudy.lead}`
        },
        {
          property: 'og:image',
          content: this.caseStudy.image.url
        },
        {
          name: 'twitter:title',
          content: this.caseStudy.name
        },
        {
          name: 'twitter:description',
          content: `${this.caseStudy.name}:  ${this.caseStudy.lead}`
        },
        {
          name: 'twitter:image',
          content: this.caseStudy.image.url
        }
      ]
    };
  }
};
</script>
<style lang="scss" src="@/assets/pages/cases.scss"></style>



// WEBPACK FOOTER //
// show.vue